import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            maxOrder: 0,
            reservedOrder: 0,
            allOrderLimitSettings: []
        };
    },
    getters: {
        maxOrder: (state) => state.maxOrder,
        reservedOrder: (state) => state.reservedOrder,
    },
    actions: {
        async getAllOrderLimitSettings({ commit }) {
            //fetch list of all quotes
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-order-limit-settings").then((data) => {
                    commit("setAllOrderLimitSettings", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getOrderLimit({ commit }, request) {
            //fetch list of all quotes
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/get-order-limit", request).then((data) => {
                    commit("setOrderLimit", data.data);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async updateOrderLimitSetting({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-order-limit-setting", request)
                    .then((data) => {
                        dispatch("getOrderLimit");
                        dispatch("getAllOrderLimitSettings");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteOrderLimitSetting({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/delete-order-limit-setting", request)
                    .then((data) => {
                        dispatch("getAllOrderLimitSettings");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        
    },
    mutations: {
        setAllOrderLimitSettings(state, allOrderLimitSettings) {
            state.allOrderLimitSettings = allOrderLimitSettings;
        },
        setOrderLimit(state, orderLimit) {
            state.maxOrder = orderLimit.max_order;
            state.reservedOrder = orderLimit.reserved_order;
        },
    },
};
